import {
  useMutation,
  type MutationFunctionOptions,
  type FetchResult,
  gql,
} from '@apollo/react-hooks';

import {
  type ApolloClient,
  type NormalizedCacheObject,
  gql as clientgql,
} from '@apollo/client';

const GET_PREVIEW_DATA = clientgql`
  query ($applicationId: String!) {
    previewOfferFiles(applicationId: $applicationId) {
      programmeCodeSubcode
      studyCommencementDate
      hasFellowship
      fellowshipSchemeFullname
      fulltimeLocal
      selfFinanced
      hasAssisstantship
      assisstantShipFullOrHalf
      residenceRequirements
    }
  }
`;

const GENERATE_FILES = gql`
  mutation ($applicationId: String!) {
    generateOfferFiles(applicationId: $applicationId) {
      file {
        id
        link
        name
      }
      checked
    }
  }
`;

export type SupersedeData = {
  programmeCodeSubcode: string;
  studyCommencementDate: string | null;
  hasFellowship: boolean;
  fellowshipSchemeFullname: string;
  fulltimeLocal: boolean;
  selfFinanced: boolean;
  hasAssisstantship: boolean;
  assisstantShipFullOrHalf: string;
  residenceRequirements: string;
};

export const useGetPreviewData = async (
  client: ApolloClient<NormalizedCacheObject>,
  applicationId: string,
): Promise<SupersedeData> => {
  const res = await client.query({
    query: GET_PREVIEW_DATA,
    variables: { applicationId },
    fetchPolicy: 'no-cache',
  });
  return (res?.data?.previewOfferFiles as SupersedeData) ?? {};
};

export const useGenerateOfferFiles = (): ((
  options?: MutationFunctionOptions,
) => Promise<FetchResult>) => {
  const [createGSDecision] = useMutation(GENERATE_FILES);

  return createGSDecision;
};
